let getDistanceForPerfectProjection = (fov, height) => {
  const vFov = fov * (Math.PI / 180)
  const z = height / (2 * Math.tan(vFov / 2))
  return z
}

export default getDistanceForPerfectProjection
